'use strict';

var UnixFs = require('ipfs-unixfs');

var waterfall = require('async/waterfall');

var series = require('async/series');

var _require = require('ipld-dag-pb'),
    DAGNode = _require.DAGNode;

var CID = require('cids');

var _require2 = require('./utils'),
    traverseTo = _require2.traverseTo,
    updateTree = _require2.updateTree,
    updateMfsRoot = _require2.updateMfsRoot,
    toSources = _require2.toSources,
    FILE_SEPARATOR = _require2.FILE_SEPARATOR;

var defaultOptions = {
  recursive: false
};

module.exports = function (ipfs) {
  return function mfsRm() {
    var args = Array.from(arguments);

    var _toSources = toSources(args, defaultOptions),
        sources = _toSources.sources,
        options = _toSources.options,
        callback = _toSources.callback;

    if (!sources.length) {
      return callback(new Error('Please supply at least one path to remove'));
    }

    series(sources.map(function (source) {
      return function (done) {
        return removePath(ipfs, source.path, options, done);
      };
    }), function (error) {
      return callback(error);
    });
  };
};

var removePath = function removePath(ipfs, path, options, callback) {
  if (path === FILE_SEPARATOR) {
    return callback(new Error('Cannot delete root'));
  }

  waterfall([function (cb) {
    return traverseTo(ipfs, path, {
      withCreateHint: false
    }, cb);
  }, function (result, cb) {
    var meta = UnixFs.unmarshal(result.node.data);

    if (meta.type === 'directory' && !options.recursive) {
      return cb(new Error("".concat(path, " is a directory, use -r to remove directories")));
    }

    waterfall([function (next) {
      return DAGNode.rmLink(result.parent.node, result.name, next);
    }, function (newParentNode, next) {
      ipfs.dag.put(newParentNode, {
        cid: new CID(newParentNode.hash || newParentNode.multihash)
      }, function (error) {
        return next(error, newParentNode);
      });
    }, function (newParentNode, next) {
      result.parent.node = newParentNode;
      updateTree(ipfs, result.parent, next);
    }, function (newRoot, next) {
      return updateMfsRoot(ipfs, newRoot.node.multihash, next);
    }], cb);
  }], callback);
};